import React, { FC, useEffect, useState } from 'react';
import { Box, Divider, LinearProgress, Typography, useTheme } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { WidgetNoData } from './WidgetNoData';

const WidgetAlerts: FC = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({
    alerts: [],
  });

  useEffect(() => {
    setTimeout(() => {
      setData({
        alerts: [
          {
            id: 1,
            date: 'vor 4h',
            text: '123 Teilnehmer bei Umfragen',
            icon: 'user',
            color: 'blue',
          },
          {
            id: 2,
            date: 'vor 12h',
            text: 'Es sind noch 12 Bewertugen unkommentiert.',
            icon: 'check',
            color: 'green',
          },
          {
            id: 3,
            date: 'vor 3T',
            text: 'Neue Suchergebnisse',
            icon: 'work',
            color: 'red',
          },
        ],
      });
      setLoading(false);
    }, 500);
  }, [setData, setLoading]);

  const createIcon = (icon: string, color: string) => {
    const components: any = {
      user: AccountCircleIcon,
      work: WorkIcon,
      check: VerifiedUserIcon,
    };
    if (typeof components[icon] !== 'undefined') {
      return React.createElement(components[icon], { style: { zIndex: 1, color: color } });
    }
    return React.createElement(() => <Box>The icon {icon} has not been defined yet.</Box>, {});
  };

  return (
    <Box>
      {loading ? (
        <Box>
          <LinearProgress sx={{ mt: theme.spacing(1), mb: theme.spacing(2) }} />
        </Box>
      ) : (
        <>
          <Divider sx={{ mt: theme.spacing(2), mb: theme.spacing(2) }} />
          <Box>
            {data.length > 0 ? (
              data.alerts.map((alert: any) => {
                return (
                  <Box
                    key={alert.id}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        flexShrink: 0,
                        fontSize: '.7em',
                        flexBasis: '70px',
                        textAlign: 'center',
                      }}
                    >
                      {alert.date}
                    </Typography>
                    <Box
                      sx={{
                        flexShrink: 0,
                        flexBasis: '50px',
                        position: 'relative',
                        overflow: 'hidden',
                        textAlign: 'center',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                      }}
                    >
                      <Box
                        sx={{
                          borderRight: '2px solid rgb(241, 241, 241)',
                          height: '50px',
                          position: 'absolute',
                          left: '19px',
                          top: '0px',
                          zIndex: 0,
                        }}
                      />

                      <Box
                        sx={{
                          borderRadius: '20px',
                          height: '40px',
                          width: '40px',
                          backgroundColor: 'rgb(241, 241, 241)',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          zIndex: 1,
                        }}
                      >
                        {createIcon(alert.icon, alert.color)}
                      </Box>
                    </Box>
                    <Typography
                      sx={{
                        flexGrow: 1,
                      }}
                    >
                      {alert.text}
                    </Typography>
                  </Box>
                );
              })
            ) : (
              <WidgetNoData />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default WidgetAlerts;
